import { Component, OnInit, HostListener, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { BuildSettings, CommonService, GetPageOfChatUsers, Config, Log, NetworkMember, HelpItemStateModel, GetProviders, GetCompasses, GetCompassAutocompletes, GetBulkSubscriptions, GetBulkSubscriptionAssignments, CompassStateModel, Provider, Compass, BulkSubscription, GetAllSettings, UserSetting, GetCompassRefresh, TrackUIEvent, GetTeamsForUser, ChatStateModel, ChatState, ChatStore, ChatStateSelector, ChatSupport, GetTeamMembers } from 'huddyapi';
import { environment } from '../environments/environment';
import { UUIDService } from './services/uuid.service';
import { DesktopStorageService } from './services/storage.service';
import { TempAuthService} from './services/tempAuthService';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialog, ConfirmationDialogButtonDefinition } from './components/confirmation-dialog/confirmation-dialog.component';

import { Subscription, interval, Observable, BehaviorSubject } from 'rxjs';
import { Store, Select } from '@ngxs/store';
import { DesktopErrorHandler } from './services/errorHandler.service';
import { Util } from './components/util';
import { DomSanitizer, Title } from '@angular/platform-browser';
import Bowser from "bowser";

import { ChatComponent } from './components/chat/chat.component';
import { CommunityConfigService, UserTeam } from './services/community-config.service';
import { Form, UntypedFormBuilder } from '@angular/forms';
import { TodoComponent } from './todo/todo.component';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [ChatStore]
})
export class AppComponent implements OnInit {
  @Select(state => state.helpItemState) helpItemState$: Observable<HelpItemStateModel>;
  readonly chatStore = inject(ChatStore);

  static compassToCopy: Compass;
  static refresherServiceSubscription: Subscription;
  static hideNavbar: string[] = ['', 'login', 'reset', 'complete'];
  static suppressOnboardingModal: string[] = ['', 'home', 'login', 'reset', 'complete'];
  static delaySizeWarning: string[] = ['accept'];
  private static _loading: boolean = true;
  static product: string = 'PROFESSIONAL';

  static loadedSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  // static homePreferenceSubject: BehaviorSubject<string> = new BehaviorSubject<string>(OnboardingDialog.HOME_PREFERENCE_LOADING);

  static set loading(loading: boolean) {
    AppComponent._loading = loading;
    const loaded: boolean = !loading;
    if(loaded != AppComponent.loadedSubject.getValue())
      AppComponent.loadedSubject.next(loaded);
  }

  static get loading(): boolean {
    return AppComponent._loading;
  }
  chatSupport : ChatSupport ;
  browserInfo: BrowserInfo;
  currentURL: string[];
  teamForm = this.formBuilder.group({
    currentTeam : {}
});
  showTeamSelector : boolean = true;
  userNetworkMember: NetworkMember;
  caresFor: NetworkMember[] = [];
  user: any;
  memberToView: NetworkMember;
  showingSettings: boolean;
  showingHelp: boolean;
  maxNavbarLinks: number;
  sizeWarningDisplayed: boolean;

  constructor(public router: Router,
    public dialog: MatDialog,
    private store: Store,
    private uuidService : UUIDService,
    private storage: DesktopStorageService,
    private commonService: CommonService,
    public communityConfig : CommunityConfigService,
    private authService: TempAuthService,
    private errorHandler: DesktopErrorHandler,
    private titleService: Title,
    private  formBuilder : UntypedFormBuilder
    ) {
    this.chatSupport = this.chatStore.getCurrentChatSupport()  ;
    this.browserInfo = this.doBrowserCheck();
    this.titleService.setTitle('Huddy Compassbuilder ' + Util.version);
    this.currentURL = [''];
    this.showingSettings = false;
    this.showingHelp = false;
    this.maxNavbarLinks = 9;
    this.sizeWarningDisplayed = false;
    console.log("App Config", environment.appConfig);
    Config.setBuildSettings(new BuildSettings(environment.appConfig));
    CommonService.appName = 'CompassBuilder';
    CommonService.appVersion = Util.version;
    CommonService.setStorageService(storage);
    CommonService.setUUIDService(uuidService);

    if (environment.production) {
      window.console.log = () => { }
    }
    CommunityConfigService.currentTeamSubject.subscribe(team => {
      console.log('currentTeamSubject', team, this.teamForm.value.currentTeam);
      const currentTeam = this.teamForm.value.currentTeam;
     
      if (team && (!currentTeam || currentTeam.teamId != team.teamId)) {

        this.teamForm.controls.currentTeam.setValue(team);
        console.log('currentTeam = ', this.teamForm.value.currentTeam, this.teamForm.value.currentTeam === this.getUserTeams()[0]);
        // this.store.dispatch(new GetPageOfChatUsers(0, 10, '', '', 'asc', team.teamId)).subscribe(state => console.log(this.chatSupport));
        this.store.dispatch(new GetTeamsForUser());
      }
    })

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {

          this.showTeamSelector =  (event.urlAfterRedirects.indexOf('work-queue') > -1);

        if (CommonService.currentUserToView){
          //Only log page visits of actual users
          this.store.dispatch(new TrackUIEvent("Visited Page " + event.urlAfterRedirects));
        }
      }
    });

    this.initialize();
   
  }

  initialize() {
      console.log('initialize');
    
      
      let fromCookie : string | null  = this.getCookie("jwt");
      if (fromCookie) {
        console.log('got fromCookie', fromCookie);
        this.startupWithJwt('Bearer ' + fromCookie);
      } else {
        try {
        this.storage.get('jwt').then(jwt => this.startupWithJwt(jwt),
          err => console.log( 'Recruitment',err));
      } catch(err) {
        console.log( 'Huddy',"ERROR IN APP COMPONENT STARTUP");
        console.log( 'Huddy', 'Huddy',err);
      }
    }



    this.storage.get('jwt').then(jwt => {
      if (!jwt || jwt == null) {

      }
      this.startupWithJwt(jwt);
    }, (error: any) => {
      this.errorHandler.handleSimple(error, DesktopErrorHandler.MESSAGE_SILENT);
      Log.logClassLevel(0, 'YDT', error)
    });
  }

  startupWithJwt(jwt? : string) {
    var hasJWTToken = (jwt !== null);
      Log.logClassLevel(0, 'YDT','App component: Has jwt token = ' + hasJWTToken);
      if(hasJWTToken && !CommonService.isLoggedOut()) {
        CommonService.setJWT(jwt);
        Log.logClassLevel(0, 'YDT',"attempting from app.component");
        this.commonService.refreshCurrentUser(jwt, true).then((user: any) => {
          if(user == null)
            this.authService.logOut();
        }, (error: any) => {
          this.errorHandler.handle(error, 'user');
          this.authService.logOut();
        });
      } 
    AppComponent.loading = true;
    this.commonService.getUserSubject().subscribe(user => {
      if(!(user && user.login))
        return;
      this.user = user;

      this.userNetworkMember = new NetworkMember(null, this.user.id, this.user.login, this.getUserName(), this.getShortName(this.user), this.user.photoURL, null, null, null, null);
      Log.logClassLevel(0, 'YDT',"======");
      Log.logClassLevel(0, 'YDT',user);
      Log.logClassLevel(0, 'YDT',"======");
      this.updateCaredFor(user);
      AppComponent.loading = true;
      Promise.all([
        this.store.dispatch(new GetProviders()).toPromise().then(async (state: any) => {
          this.configureApp(state.compassState.primaryProduct);
          if (CommunityConfigService.isCommunity) {
            this.store.dispatch(new GetTeamsForUser());
            CommunityConfigService.init();
          } 
          // this.store.dispatch(new GetPageOfChatUsers(0, 10, '', '', 'asc')).subscribe(state => console.log(this.chatSupport));

          return await Promise.all([
            this.store.dispatch(new GetCompasses()).toPromise().catch((error: any) => this.errorHandler.handle(error, 'compasses')),
             this.store.dispatch(new GetBulkSubscriptions((state.compassState as CompassStateModel).providers.map((provider: Provider): number => provider.id))).toPromise()
             //.then(
              // async (state: any) => {
              //   return await this.store.dispatch(new GetBulkSubscriptionAssignments((state.compassState as CompassStateModel).subscriptions.map((subscription: BulkSubscription): number => subscription.id)))
              //     .toPromise().catch((error: any) => this.errorHandler.handle(error, 'assignments'));
              // }
            // ).catch((error: any) => this.errorHandler.handle(error, 'subscriptions'))
          ]);
        }).catch((error: any) => this.errorHandler.handle(error, 'providers')),
        this.store.dispatch(new GetCompassAutocompletes()).toPromise().catch((error: any) => this.errorHandler.handle(error, 'compass autocomplete data'))
      ]).finally(() => AppComponent.loading = false);
    });
    
    this.commonService.getCurrentUserToViewSubject().subscribe((email: string) => {
      if(!email)
        return;
    });
  }

  getCookie(name: string) {
      let ca: Array<string> = document.cookie.split(';');
      let caLen: number = ca.length;
      let cookieName = `${name}=`;
      let c: string;

      for (let i: number = 0; i < caLen; i += 1) {
          c = ca[i].replace(/^\s+/g, '');
          if (c.indexOf(cookieName) == 0) {
              return c.substring(cookieName.length, c.length);
          }
      }
      return '';
  }

  doBrowserCheck(): BrowserInfo {
    let result: BrowserInfo = { small: false, os: null, blockReason: null };
    const browser: Bowser.Parser.Parser = Bowser.getParser(window.navigator.userAgent);
    if(browser.getPlatformType(true) != 'desktop' && (window.outerWidth < 500 || window.outerHeight < 500))
      result.small = true;
    result.os = browser.getOSName(true);
    const versionIsValid: boolean = browser.satisfies({
      chrome: '>=79',
      firefox: '>=75',
      safari: '>=11.1',
      edge: '>=79',
      opera: '>=66'
    });
    if(!versionIsValid)
      result.blockReason = 'The Huddy desktop app does not support your browser version.  To continue, update your browser or use a different browser.';
    return result;
  }

  browserBlocked(): boolean {
    return this.browserInfo && this.browserInfo.blockReason != null;
  }

  updateCaredFor(user) {
    Log.logClassLevel(0, 'YBasic',"in updateCaredFor", user);
    if(!user || !user.whyUser)
      return;
    this.caresFor = (user.whyUser.trustors || []).filter((trustedUser: any) => {
      return trustedUser.userType == 'LOG_FOR';
    }).map((trustedUser: any) => {
      return new NetworkMember(trustedUser.id, trustedUser.trustorId, trustedUser.userEmail,
        trustedUser.userName || trustedUser.userEmail, trustedUser.userName || trustedUser.userEmail, trustedUser.photoURL,
        trustedUser.userType, true, null, null);
    });
    const userToViewEmail: string = this.commonService.getCurrentUserToView();
    if(userToViewEmail == null)
      return;
    if(user.email == userToViewEmail)
      this.memberToView = NetworkMember.convertUser(user);
    else {
      this.memberToView = this.caresFor.find((member: NetworkMember): boolean => {
        return member.email == userToViewEmail;
      });
    }
  }

  ngBeforeInit(){
    // Config.setBuildSettings(new BuildSettings(environment.appConfig));
    CommonService.setStorageService(this.storage);
    CommonService.setUUIDService(this.uuidService);
  }

  showNavbar() : boolean {
    return   AppComponent.hideNavbar.indexOf(this.currentURL[0]) == -1;
  }

  ngOnInit() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd))
      .subscribe((e: NavigationEnd) => {
        this.currentURL = (e.urlAfterRedirects || '').substring(1).split('/').join(',').split('?').join(',').split(';').join(',').split(',');
       
        // if(!this.sizeWarningDisplayed && this.browserInfo && this.browserInfo.small && !this.browserInfo.blockReason && !AppComponent.delaySizeWarning.includes(this.currentURL[0])) {
        //   this.sizeWarningDisplayed = true;
        //   let link: string;
        //   switch(this.browserInfo.os) {
        //     case 'ios':
        //       link = 'https://apps.apple.com/us/app/huddy-health/id1200975683';
        //       break;
        //     case 'android':
        //       link = 'https://play.google.com/store/apps/details?id=io.huddyhealth.huddy';
        //       break
        //     default:
        //   }
        //   let buttons: ConfirmationDialogButtonDefinition[] = [{
        //     text: 'Not now',
        //     class: link ? 'secondary' : '',
        //     handler: () => null
        //   }];
        //   if(link) {
        //     buttons.push({
        //       text: 'Try it',
        //       class: '',
        //       handler: () => window.open(link, '_blank')
        //     });
        //   }
        //   this.dialog.open(ConfirmationDialog, {
        //     width: '636px',
        //     data: {
        //       minWidth: '155px',
        //       title: 'Try our mobile app',
        //       body: 'The Huddy desktop app is not designed for small screens, so we suggest that you use the Huddy mobile app for iOS or Android instead.',
        //       buttons: buttons
        //     }
        //   });
        // }
      });
    if(AppComponent.refresherServiceSubscription == null) {
      AppComponent.refresherServiceSubscription = interval(30000).subscribe(() => {
        if(this.commonService.getCurrentUserToView())
          this.store.dispatch(new GetCompassRefresh()).toPromise().catch((error: any) => {
            return this.errorHandler.handle(error, null, { default: DesktopErrorHandler.MESSAGE_SILENT });
          });
      });
    }
  }

  checkRoute(route: string): boolean {
    return this.currentURL && this.currentURL.length > 0 && this.currentURL[0] == route;
  }

  settingsSelected(): boolean {
    if(this.checkRoute('patients'))
      return this.maxNavbarLinks < 3;
      if(this.checkRoute('work-queue'))
      return this.maxNavbarLinks < 3;
    if(this.checkRoute('families'))
      return this.maxNavbarLinks < 4;
    if(this.checkRoute('compasses'))
      return this.maxNavbarLinks < 5;
    if(this.checkRoute('builder'))
      return this.maxNavbarLinks < 6;
    if(this.checkRoute('settings'))
      return this.maxNavbarLinks < 7;
      if(this.checkRoute('logout'))
      return this.maxNavbarLinks < 8;
    return false;
  }

  helpSelected(): boolean {
    return this.checkRoute('products');
  }

  tryToFollowLink(route: string) {
    this.clearPopover();
    if(!this.checkRoute(route))
      this.router.navigate([route]);
  }

  logOut() {
    this.dialog.open(ConfirmationDialog, {
      width: '636px',
      data: {
        minWidth: '127px',
        title: 'Sign out',
        body: 'Are you sure you want to sign out?',
        buttons: [
          {
            text: 'Cancel',
            class: 'secondary',
            handler: (): boolean => {
              return false;
            }
          },
          {
            text: 'Sign out',
            class: '',
            handler: (): Promise<boolean> => {
              return this.authService.logOut().then(() => {
                return true;
              }, (error: any) => {
                this.errorHandler.handle(error, 'logout', DesktopErrorHandler.COMMON_MESSAGES);
                return false;
              });
            }
          }
        ]
      }
    });
  }

  showSettings() {
    this.showingSettings = true;
  }

  showHelp() {
    this.showingHelp = true;
  }

  showingPopover(): boolean {
    return this.showingSettings || this.showingHelp;
  }

  clearPopover() {
    this.showingSettings = false;
    this.showingHelp = false;
  }

  getUserName() : string {
    let ret = '';
    if (this.user)
     ret = this.getName(this.user);
    return ret;
  }

  getName(user: any) {
    if(!user)
      return;
    if(user.firstName && user.lastName)
      return user.firstName + ' ' + user.lastName;
    return this.getShortName(user);
  }

  getShortName(user: any) {
    if(!user)
      return;
    if(user.firstName)
      return user.firstName;
    if(user.lastName)
      return user.lastName;
    if (user.email) {
        let index = user.email.indexOf('@');
        return index < 0 ? user.email : user.email.substring(0, index);
    }
    return "";
  }

  getPopoverVariables(index: number = this.maxNavbarLinks - 1) {
    return '--button-index:' + index + ';--num-buttons:' + this.maxNavbarLinks + ';'
      + (this.maxNavbarLinks < 1 ? '--arrow-point:25vh;' : '');
  }

  openChat() {
    const dialog = this.dialog.open(ChatComponent, {
      width: '600px',
      height: '575px',
      data: {}
    });
  }

  isValidRole(role: string) {
    let validRole: boolean = false;
    for (let auth of this.user.authorities) {
      if (role == auth) {
        validRole = true;
      }
    }

    return validRole;
  }

  getVersion(): string {
    return Util.version;
  }

  configureApp(primaryProduct : string) {
    AppComponent.product = primaryProduct;
    CommunityConfigService.isCommunity = AppComponent.product === 'COMMUNITY';
    console.log('SETTING PRODUCT TO '+ primaryProduct  );
    this.router.navigate([this.resolveHome()]);
  }

  resolveHome() : string {
    return (AppComponent.product === 'COMMUNITY') ? 'work-queue' : 'patients';
  }

  @HostListener('window:load', ['$event'])
  @HostListener('window:resize', ['$event'])
  handleResize(event: any) {
    const height: number = event.currentTarget.innerHeight;
    const scale: number = Math.max(0.625, height / 800);
    this.maxNavbarLinks = 8;//Math.min(9, Math.floor((height - (192 * scale + 92)) / (32 * scale + 39)));
    // if(this.maxNavbarLinks == 9 && this.showingSettings)
    //   this.clearPopover();
  }

  getUserTeams(): UserTeam[] {
    return CommunityConfigService.userTeams;
  }

  setCurrentTeam($event) {
    console.log('setting current team', $event.value);
    CommunityConfigService.setCurrentTeam($event.value);
  }
  teamComparator(team1 : UserTeam, team2 : UserTeam) {
    if (team1.teamId == team2.teamId) {
      return team1.teamName;
    } else {
      return "";
    }
  }

  hasRole(teamRole : string) {
    return CommunityConfigService.hasRole(teamRole);
  }
}

interface BrowserInfo {
  small: boolean;
  os: string;
  blockReason: string;
}
